import * as React from 'react'
import { LeadPage } from '../Leads/LeadPage'
import { ProtectedRouteWithToast } from '../Routes'
import { useCheckPermissions } from '@user/store/authorization/permissions'

export const DraftLeadRoutes: React.FC = () => {
  const [canViewLeads, canUpdateLeads, canDeleteLeads, canConvertLead] =
    useCheckPermissions(
      'leads_view',
      'leads_update',
      'leads_delete',
      'opportunities_convert_/_save_for_later',
    )

  const canConvertLeads = React.useMemo(
    () => canConvertLead && canUpdateLeads,
    [canConvertLead, canUpdateLeads],
  )

  return (
    <ProtectedRouteWithToast isAllowed={canViewLeads}>
      <LeadPage
        isDraft={true}
        canUpdateLeads={canUpdateLeads}
        canConvertLeads={canConvertLeads}
        canDeleteLeads={canDeleteLeads}
      />
    </ProtectedRouteWithToast>
  )
}
DraftLeadRoutes.displayName = 'DraftLeadRoutes'
